import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page30() {
  useEffect(() => {
    document.title = "Маяк — Страница 29"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page28" />
        <ForwardLink href="/page30" />
      </div>

      <p style={{ textAlign: "right" }}>29.</p>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. ГОСТИНАЯ/ПЕРЕДНЯЯ – ВЕЧЕР</p>
      <p>
        СТАРИК смотрит сквозь крошечные изящные очки, надетые на переносицу.<br/>
        Кончик левого виска слишком высок и не заходит за ухо.
      </p>
      <p>
        Он заканчивает запись в ЖУРНАЛЕ. Он выводит<br/>
        “период” с удовольствием.
      </p>
      <p>Ручку в сторону. Книга закрыта. Очки сняты.</p>
      <p>
        Он с грохотом закрывает стол и запирает его<br/>
        самым маленьким КЛЮЧОМ на цепочке.
      </p>
      <p>КАМЕРА врезается в замок.</p>
      <p>
        РЕВЕРСИВНО: МОЛОДОЙ ПРЯЧЕТСЯ В ТЕНИ вестибюля...<br/>
        НАБЛЮДАЕТ.
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – НОЧЬ</p>
      <p>СТАРИК сидит на том же стуле, на котором сидел последние
      недели. МОЛОДОЙ на перевернутом БОЧОНКЕ ДЛЯ ГВОЗДЕЙ.</p>
      <p>
        МОЛОДОЙ крутит СУХАРЬ в руке. Он размышляет о том, чтобы его съесть.<br/>
        УДАРЯЕТ его об стол. Печенье звенит как металл.<br/>
        <i>Нет.</i>
      </p>
      <p>Вместо этого МОЛОДОЙ наливает выпивку СТАРИКУ. Передает ему.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Спасибо, парень.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Уинслоу.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        --?
      </p>
      <p>МОЛОДОЙ набирается немного храбрости.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Эфраим Уинслоу. Эти последние две<br/>
        недели, я... ну, я бы хотел,<br/>
        сэр, чтобы Вы называли меня по имени.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Слушай, парень, ты раздаешь приказы.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Уинслоу.
      </p>
      <p style={{ textAlign: "right" }}>29.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page28" />
        <ForwardLink href="/page30" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710020054/the-lighthouse-script/l1cpg1sk4j8blhyidg2o.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page30;
